export const defaultDemoUser = {
    id: 'demo-visitor',
    email: 'visitor@demo.local',
    displayName: 'Demo Visitor',
};
